import { Content } from './types'

const quote: Content = {
    type: 'quote',
    name: 'Citaat',
}

export default quote
